export type SunTimes = {
  sunriseHour: number;
  sunsetHour: number;
};

/** Derive sun bounds only from forecast-authored daylight flags. */
export function authoritativeDaylightBounds(
  hours: readonly { hour: number; weather: { is_day: boolean } }[],
): SunTimes | null {
  const daylight = hours.filter(({ weather }) => weather.is_day);
  const first = daylight[0];
  const last = daylight[daylight.length - 1];
  return first && last
    ? { sunriseHour: first.hour, sunsetHour: last.hour + 1 }
    : null;
}

export function parseSunTimes(
  sunriseIso: string,
  sunsetIso: string
): SunTimes {
  const toDecimal = (iso: string) => {
    const d = new Date(iso);
    return d.getHours() + d.getMinutes() / 60;
  };
  return {
    sunriseHour: toDecimal(sunriseIso),
    sunsetHour: toDecimal(sunsetIso),
  };
}

export function daylightScore(hour: number, sun: SunTimes): number {
  const goldenDuration = 0.75;

  if (
    hour < sun.sunriseHour - goldenDuration ||
    hour > sun.sunsetHour + goldenDuration
  ) {
    return 0;
  }
  if (hour < sun.sunriseHour) {
    return 80;
  }
  if (hour > sun.sunsetHour) {
    return 80;
  }
  if (
    hour < sun.sunriseHour + goldenDuration ||
    hour > sun.sunsetHour - goldenDuration
  ) {
    return 80;
  }
  return 100;
}

export function isDark(hour: number, sun: SunTimes): boolean {
  return daylightScore(hour, sun) === 0;
}
